import type { NowPlayingTrack } from '../native/music-listener-native';
import type { MusicDictionary, MusicGenre } from './types';

export type ClassifierResult = MusicGenre | 'other' | null;

const TITLE_KEYWORD_RULES: Array<{ pattern: RegExp; genre: MusicGenre }> = [
    { pattern: /\blofi|lo-fi\b/i, genre: 'lofi' },
    { pattern: /\bclassical|symphony|concerto\b/i, genre: 'classical' },
    { pattern: /\bremix|edm|techno|house\b/i, genre: 'electronic' },
    { pattern: /\bambient|asmr\b/i, genre: 'ambient' },
    { pattern: /\bjazz|bebop|swing\b/i, genre: 'jazz' },
];

export function classifyGenre(
    track: NowPlayingTrack | null,
    dict: MusicDictionary,
): ClassifierResult {
    if (!track) return null;
    if (track.state !== 'playing') return null;

    const artistKey = track.artist.toLowerCase().trim();
    if (artistKey && dict.artist_to_genre[artistKey]) return dict.artist_to_genre[artistKey];

    const titleAndArtist = `${track.title} ${track.artist}`;
    for (const rule of TITLE_KEYWORD_RULES) {
        if (rule.pattern.test(titleAndArtist)) return rule.genre;
    }

    const hint = dict.package_hints[track.packageName];
    if (hint) return hint;

    return 'other';
}
